module.exports = __webpack_public_path__ + "media/images/85/sleep_apnea_get_good_sleep-3522698c70d4c24e1c511c64b4721daa.webp";